import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

export function showPopup<T extends React.ElementType>(
  popup: T,
  props: React.ComponentProps<T>
) {
  const container = document.createElement('div');
  const root = createRoot(container);

  root.render(createElement(popup, props));

  return { root, container };
}

export function onPopupClose({
  root,
  container
}: ReturnType<typeof showPopup>) {
  root.unmount();
  container.remove();
  document.body.removeAttribute('style');
}
